import BigNumber from 'bignumber.js';
import { useConnection } from 'modules/auth';
import { useGetBtcPriceQuery } from 'modules/common/actions/getBtcPrice';
import { ConnectWalletBtn } from 'modules/common/components/ConnectWalletBtn';
import { ACTION_CACHE_LONG } from 'modules/common/const';
import { formatBigNumberShort } from 'modules/common/utils/formatBigNumber';
import { useGetUserLbtcVaultSupplyQuery } from 'modules/dashboard/actions/getUserLbtcVaultSupply';
import { useTranslation } from 'modules/i18n';
import { StatsBlock } from '../StatsBlock';
import { translation } from './translation';

export function UserAssetsInVault(): JSX.Element {
  const { address = '', isConnected, isSwitchNetworkLoading } = useConnection();
  const { t, keys } = useTranslation(translation);

  const { data: btcPrice = 0, isLoading: isBtcPriceLoading } =
    useGetBtcPriceQuery(undefined, {
      refetchOnMountOrArgChange: ACTION_CACHE_LONG,
    });

  const { data = 0, isLoading: isLbtcSupplyLoading } =
    useGetUserLbtcVaultSupplyQuery(address, {
      skip: !isConnected || !address,
      pollingInterval: 15_000,
    });

  const totalSupply = new BigNumber(data);

  const usdValue = totalSupply.multipliedBy(btcPrice);

  const formattedUsdValue = formatBigNumberShort(usdValue);

  const usdText = t('unit.usdValue', {
    value: formattedUsdValue,
  });

  const lbtcValueText = t(keys.tvlLabel, {
    value: formatBigNumberShort(totalSupply, 6),
  });

  return (
    <StatsBlock
      title={t(keys.title)}
      mainValue={usdText}
      value={lbtcValueText}
      isLoading={
        isBtcPriceLoading || isLbtcSupplyLoading || isSwitchNetworkLoading
      }
      content={isConnected ? null : <ConnectWalletBtn fullWidth size="small" />}
    />
  );
}
